import { Injectable } from '@angular/core';
import { AnalyticsBrowser, InitOptions } from '@segment/analytics-next';

// Segment's FullStory destination assigns window._fs_is_outer_script from its
// CDN settings, overwriting the value set in assets/fs-init.js. When false and
// the app is framed (the CreditLens-integrated flow), fs.js waits for a parent
// FullStory recorder that does not exist and never starts a session. Forcing
// it on here makes the app record as its own session regardless of workspace config.
export const SEGMENT_INIT_OPTIONS: InitOptions = {
  integrations: {
    FullStory: { isOuterScript: true },
  },
};

@Injectable({ providedIn: 'root' })
export class SegmentService {
  // Instantiated unloaded so calls made before load() (e.g. the identify fired
  // by UserService during app bootstrap, which races the /api/environment
  // fetch) are buffered and replayed once the write key arrives, instead of
  // being dropped.
  private analytics: AnalyticsBrowser = new AnalyticsBrowser();
  private loaded = false;

  public load(writeKey: string): Promise<void> {
    if (!writeKey || this.loaded) {
      return Promise.resolve();
    }
    this.loaded = true;
    this.analytics.load({ writeKey }, SEGMENT_INIT_OPTIONS);
    return Promise.resolve();
  }

  public identify(userId: string, traits?: any, options?: any): Promise<void> {
    this.analytics.identify(userId, traits, options);
    return Promise.resolve();
  }

  public track(event: string, properties?: any, options?: any): Promise<void> {
    this.analytics.track(event, properties, options);
    return Promise.resolve();
  }

  public page(category?: string, name?: string, properties?: any, options?: any): Promise<void> {
    this.analytics.page(category, name, properties, options);
    return Promise.resolve();
  }

  public group(groupId: string, traits?: any, options?: any): Promise<void> {
    this.analytics.group(groupId, traits, options);
    return Promise.resolve();
  }

  public alias(userId: string, previousId?: string, options?: any): Promise<void> {
    this.analytics.alias(userId, previousId, options);
    return Promise.resolve();
  }

  public reset(): void {
    this.analytics.reset();
  }
}
